import React, { Fragment, useState, useCallback } from "react";
import { FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { TD } from "styled/table";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import {convertToIndianTimezoneAndGetDate, formatMonthYear} from "utils/helpers";
import {formatDate} from "utils/helpers";
import DeleteCPKM from "./delete";

const ViewList = ({ idx, data, getData, page, limit }) => {
    // console.log('data',data);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [showDeleteModel, setShowDeleteModel] = useState(false);
    const currentUser = useSelector((state) => state.user.currentUser);
    const formattedMonthYear = formatMonthYear(data.monthYear);
    const formattedDate = convertToIndianTimezoneAndGetDate(data._id.uploadedAt, true);
  
    const modalHandler = useCallback(
      (data) => {
        if (data) {
          setModalData(data);
          setShowModal(true);
        } else {
          setShowModal(false);
          setModalData([]);
        }
      },
      [showModal, modalData]
    );
  
    return (
      <Fragment>
        <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
          <TD>{(page-1)*limit + idx + 1}</TD>
          <TD>{formattedMonthYear}</TD>
          <TD>{data.fleetName}</TD>
          <TD>{data.uploadedBy}</TD>
          <TD>{formattedDate}</TD>
          <TD>{data.billedCPKM}</TD>
          <TD>
            {checkPermission([permissions.delete_cpkm], currentUser) ? (
              <div className="">
                <button
                  onClick={() => setShowDeleteModel(true)}
                  className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
                >
                  <FaTrash />
                </button>
              </div>
            ) : (
              <p>----</p>
            )}
          </TD>
        </tr>
        {showDeleteModel && (
          <DeleteCPKM
            fleet={data._id.fleet}
            date= {data._id.uploadedAt}
            data= {data}
            handleClick={() => setShowDeleteModel(false)}
            getData={getData}
            page ={page}
          />
        )}
      </Fragment>
    )
}

export default ViewList;